module.exports = __webpack_public_path__ + "files/1e38d6dea3e3d22421f7751aeb3b0fff.png";